// import IArticleAuthor from "Interfaces/article-author";

export const SERVER = 'server';
export const CLIENT = 'client';

export const PAGE = 'page';
export const CONFIGDATA = 'config';
export const LABELS = 'labels';
export const NAVDATA = 'nav';
export const MARKETDATA = 'market';
export const CONTAINERDATA = 'container';
export const SUBMENUDATA = 'subMenu';
export const CARDDATA = 'card';
export const MYOCDATA = 'myoc';
export const SUBSCRIPTIONS = 'subscriptions';
export const TIPDATA = 'tip';
export const PAGEDATA = 'page';
export const TAKEOVERDATA = 'takeover';
export const SEARCHDATA = 'search';
export const HEROCARDDATA = 'heroCard';
export const SEARCHBANNERDATA = 'searchBanner';
export const ADSERVERDATA = 'adServer';
export const APIRESPONSE = 'apiResponse';
export const RELATEDTIPS = 'relatedTips';
export const LEFTHANDCONTAINER = 'leftHandContainer';
export const SUBEVENTDATA = 'subevent';
export const CATEGORYGROUPNAME = 'categoryGroupName';
export const ARTICLE = 'article';
export const PICKSCONTAINER = 'picksContainer';

// CLIENT STORE
export const CURRENT_PATH = 'currentPath';
export const SHOW_SPINNER = 'showSpinner';
export const US_STATE = 'usState';

// CONFIG DATA
export const BASE_URL = 'baseUrl';
export const GEO_STATE_LOCATION_ORIGIN = 'geoStateLocationOrigin';
export const GEO_STATE_LOCATION = 'geoStateLocation';

/* Betslip */
export const BETSLIP_OPEN = 'betslipOpen';
export const BETSLIPDATA = 'betslip';
export const BETSLIPCOOKIE = 'intBetslipCookie';
export const BETSLIP = 'Betslip';
export const BET_ADDED = 'betAdded';

/* Betslip tracking */
export const CLOSE_BETSLIP = 'Close Betslip';
export const OPEN_BETSLIP = 'Open Betslip';
export const SELECT_BOOKIE = 'Select Bookie';
export const CLEAR_BETSLIP = 'Clear Betslip';
export const REMOVE_BET = 'Remove Bet';
export const CHANGE_BOOKIE_SELECTION = 'Change bookie selection';
export const BET_ON_BOOKMAKER_SITE = 'Bet on bookmaker site click';
export const BETSLIP_ICON_CLICKED = 'Betslip Icon Clicked';

/* Config Data */
export const DEVICE = 'device';
export const BREADCRUMBS = 'breadcrumbs';
/* End of Config Data */

/* Pages */
export const HOMEPAGE = 'HOMEPAGE_NEW';
export const SPORTCATEGORYPAGE = 'SportCategoryPage';
export const CONTENTPAGE = 'ContentPage';

// OLD Content Pages - using Tools
const TIPS_PAGES = ['TipHomepageNew', 'TipCategoryNew', 'TipArticle'] as const;
const NEWS_PAGES = ['NewsHomepage', 'NewsCategory', 'NewsArticle'] as const;

// NEW Content Pages - using Contentful
const PICKS_PAGES = [
	'PicksHub',
	'PicksHubPagination',
	'PicksHubV2',
	'PicksHubWithCards',
	'PicksHubPaginationV2',
	'PicksCategory',
	'PicksCategoryPagination',
	'PicksCategoryV2',
	'PicksCategoryWithCards',
	'PicksCategoryPaginationV2',
	'PicksArticle',
	'PicksArticleV2',
] as const;
const INSIGHTS_PAGES = [
	'InsightsHub',
	'InsightsHubPagination',
	'InsightsCategory',
	'InsightsCategoryPagination',
	'InsightsArticle',
] as const;
const BETTING_GUIDES_PAGES = [
	'BettingGuidesHub',
	'BettingGuidesCategory',
	'BettingGuidesArticle',
] as const;
const AUTHOR_PAGES = ['AuthorProfile', 'AuthorHub', 'AuthorCategory'] as const;
const HANDICAPPER_PAGES = [
	'HandicapperProfile',
	'HandicapperHub',
	'HandicapperCategory',
	'HandicapperHubPaginated',
] as const;

const PROMO_PAGES = ['PromoCode'] as const;
const REVIEW_PAGES = ['Review'] as const;

const LEGISLATION_PAGES = ['LegislationHubV2', 'LegislationPageV2'] as const;

export const CONTENTFUL_PAGES = [
	...BETTING_GUIDES_PAGES,
	...INSIGHTS_PAGES,
	...PICKS_PAGES,
	...AUTHOR_PAGES,
	...HANDICAPPER_PAGES,
	...PROMO_PAGES,
	...REVIEW_PAGES,
	...LEGISLATION_PAGES,
];

export const ARTICLE_PAGES = [
	...NEWS_PAGES,
	...TIPS_PAGES,
	...CONTENTFUL_PAGES,
];

export const ARTICLE_TAGS = [
	'NFL',
	'NCAAF (College Football)',
	'Football',
	'NBA',
	'Basketball',
	'NHL',
	'Hockey',
	'Golf',
	'MLB',
	'Baseball',
	'Soccer',
	'Horse Racing',
	'Boxing',
	'MMA',
	'Boxing/MMA',
	'Politics',
];

/* Navigation */
export const EVENTMENU = 'eventMenu';
export const SPORTMENU = 'sportMenu';
export const SMALLMENU = 'smallMenu';

export const ALLSPORTITEMS = 'AllSportItems';

export const SPORTSITEMS = 'SportItems';
export const HEADERITEMS = 'HeaderItems';
export const FOOTERITEMS = 'FooterItems';

export const SELECT = 'select';
export const COUNTRIES = 'countries';
/* End of Navigation */

/* MYOC */
export const NEWSLETTER = 'oc_newsletter';
export const BOOKIEOFFERS = 'bookie_offers';
/* End of MYOC */

/* Profile Badges Sports */
export const PROFILEBADGESSPORTS = ['tennis'];
/* End of Profile Badges Sports */

/* Theme */
export const THEME_SPORTS = [
	'football',
	'tennis',
	'basketball',
	'horse_racing',
];
// Arrays for the bookies that use dark font
export const THEME_ES = ['FS', 'PA'];
export const THEME_IT = ['BI', 'FB', 'FI', 'FL', 'GI', 'LM', 'NE', 'SK', 'MW'];
export const THEME_DE = ['BT', 'FB', 'OL', 'NE', 'SN'];
export const THEME_DK = ['BF', 'DB'];
export const THEME_AU = [
	'BF',
	'CR',
	'PB',
	'RB',
	'SJ',
	'SP',
	'TP',
	'TW',
	'TT',
	'VK',
	'CS',
];

/* Horse Racing */
export const SORT_BY_MAP = [
	['bestOddsDecimal', 'Favourite'],
	['name', 'Name'],
	['raceCardNumber', 'Card Number'],
	['stall', 'Barrier Number'],
	['result', 'Results'],
];

export const LEGALIMAGES = ['US'];

export const SUBDOMAINMAP = {
	LOCALHOST: 'localhost.',
	DEV: 'dev.',
	TEST: 'test.',
	LIVE: '',
	STAGING: 'stg.',
};

export const PAGEVIEWS = {
	DEFAULTCARD: 'defaultCard',
	COUPONCARD: 'couponCard',
};

export const NON_TEAM_SPORTS = [
	'tennis',
	'boxing',
	'mma',
	'golf',
	'cycling',
	'darts',
	'badminton',
];

export const AMERICAN_SPORTS = [
	'ice hockey',
	'baseball',
	'basketball',
	'american football',
];

export const DEFAULT_OFFER_IMAGE = 'types/HM2/offer-carousel-default.jpg';
// TODO, remove hardcoded links in header-utils-actions and use the array below

export const CONTENTFUL_IMAGE_DOMAIN = '//images.ctfassets.net';

export const TWITTER_EMBED_JS = 'https://platform.twitter.com/widgets.js';
export const INSTAGRAM_EMBED_JS = 'https://www.instagram.com/embed.js';

// Cookies

export const NEXT_UP_GAME_TAB = 'next_up_game_tab';

// Modals
export const myOCLoginModals = [
	'LoginForm',
	'LoginVerificationForm',
	'SignupForm',
];

export const myOCLoginModalsEmbeddedInPremiumModals = ['BetaSignupForm'];

export const premiumModals = [
	'PremiumProductForm',
	'PremiumPaymentVerification',
	'PremiumPaymentSuccess',
	'PremiumPaymentFailure',
];

export const betaModals = ['BetaSuccess'];

export const allModals = [
	...myOCLoginModals,
	...myOCLoginModalsEmbeddedInPremiumModals,
	...premiumModals,
];

// export const OC_TEAM_AUTHOR: IArticleAuthor[] = [
//   {
//     name: "OddsChecker Team",
//     url: "handicappers",
//     bioImage: {
//       url: "",
//       alt: "OddsChecker Team",
//     },
//   },
// ];
